import { createTypedHooks } from 'easy-peasy';
import { StoreModel } from 'app/state/api/interfaces';

const typedHooks = createTypedHooks<StoreModel>();

export const { useStoreActions } = typedHooks;
export const { useStoreState } = typedHooks;
